module.exports = __webpack_public_path__ + "static/media/check-fill.a073057b.svg";